<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>
                        Division Level Chess Meet 2025 – Nagpur
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png" />
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">

        <div class="row justify-content-between">
            <div class="col-md-12">

                <!-- <ul class="list-style list-style1 mb-3">
                        <li>Date: 20th July 2025</li>
                        <li>Venue: G H Raisoni Education of Information Technology, Shraddha Park, Wadi-Hingna Link Road,
                            Nagpur</li>
                    </ul> -->

                <p>Nagpur, 29th September 2025 – The District Sports Office, Government of Maharashtra, under the aegis
                    of the Directorate of Sports and Youth Services, Pune, in association with the G.H. Raisoni Sports
                    and Cultural Foundation and Chess Association Nagpur, successfully organized the Division Level
                    Chess Meet at G.H. Raisoni Institute of Information Technology, Shraddha Park, Hingna, Nagpur. The
                    meet served as a selection event for the upcoming Maharashtra State Level Chess Championships.</p>
                <h5 class="primary-purple">Winners</h5>
                <ul class="list-style list-style1 mb-3">
                    <p><strong>Girls Category</strong></p>
                    <li>Under-14: Anvi Hirde (Champion, 5½ points) | Runner-up: Nrutya Gurve (5 points)</li>

                    <li>Under-17: Riddhi Agrawal | Runner-up: Shraddha Bajaj</li>

                    <li>Under-19: Lakshita Kranti Rathod | Runner-up: Swanandi Sole </li>
                    <p> <strong> Boys Category</strong></p>
                    <li>Under-14: Anay Pimparkar | Runner-up: Kushagra Paliwal

                    </li>
                    <li>Under-17: Nihaan Pohane | Runner-up: Arush Chitre</li>
                    <li>Under-19: Saksham Wadhwa | Runner-up: Ayush Ramteke</li>
                    <p>A total of <strong>240 players</strong> from various districts participated in the championship.
                    </p>
                </ul>
                <h5 class="primary-purple"> Prize Distribution Ceremony</h5>
                <p>The prize distribution was graced by Dr. Achal Shahare (Registrar, GHRCEM), Dr. Akhilesh Ugale
                    (Registrar, G.H. Raisoni University, Guest of Honour), along with Shri Bhushan Shriwas (Secretary,
                    Chess Association Nagpur) and Smt. Maya Dubale (Incharge, DSO Chess Meet).

                    Smt. Maya Dubale expressed gratitude to Shri Sunil Raisoni, Chairman of G.H. Raisoni Group, and Dr.
                    Vivek Kapoor, Vice-Chancellor of G.H. Raisoni University, for their support in hosting the event.
                </p>


                <h5 class="primary-purple">Arbiters Panel:</h5>
                <p>The tournament was officiated by IA Shiva Iyer (Chief Arbiter), supported by FA Amit Tembhurne, SNA
                    Prayas Ambade, Prathamesh Machave, and team.



            </div>
            <div class="col-md-12">
                <div class="sec-title mt-4 text-center">
                    <h2><span>Photo Gallery</span></h2>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                        <!-- <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li> -->
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
